"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var login_service_1 = require("../../services/login.service");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var login_status_enum_1 = require("../../provider/enums/login-status.enum");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
/**
 *
 *
 *
 * This is the base component for log in.
 * You should inherit it and provide your own template and styles.
 * You may use as an example
 * {@see DemoLoginComponent}
 *
 *
 *
 */
var LoginComponent = /** @class */ (function () {
    function LoginComponent(loginService, sessionDataProvider, languageService, messageService) {
        var _this = this;
        this.loginService = loginService;
        this.sessionDataProvider = sessionDataProvider;
        this.languageService = languageService;
        this.messageService = messageService;
        this.languages = [];
        this.isUserBlocked = false;
        this.validationMessage = undefined;
        this.verificationMessage = undefined;
        this.showTwoFactorAuthentication = false;
        this.verificationType = idm_authentication_client_js_1.VerificationType.EMAIL;
        this.openSubscriptions = [];
        var subscription = this.languageService
            .getAvailableLanguages()
            .subscribe(function (languages) {
            _this.languages = languages;
        });
        this.openSubscriptions.push(subscription);
    }
    LoginComponent.prototype.ngOnDestroy = function () {
        this.openSubscriptions.forEach(function (subscription) { return subscription.unsubscribe(); });
    };
    /**
     * Change current language
     */
    LoginComponent.prototype.changeLanguage = function ($event, languageId) {
        $event.preventDefault();
        this.sessionDataProvider.setCurrentLanguageId(languageId);
    };
    /**
     * Checks if language is the current one.
     * @param languageId
     * */
    LoginComponent.prototype.isCurrentLanguage = function (languageId) {
        return this.sessionDataProvider
            .getCurrentLanguage()
            .take(1)
            .map(function (language) {
            return languageId === language.getId();
        });
    };
    LoginComponent.prototype.login = function (event, username, password) {
        var _this = this;
        event.preventDefault();
        this.loginService.loginOrGetErrorMessage(username, password).catch(function (loginObject) {
            switch (loginObject.loginStatus) {
                case login_status_enum_1.LoginStatus.EXPIRED:
                    break;
                case login_status_enum_1.LoginStatus.BLOCKED:
                    _this.isUserBlocked = true;
                    _this.toBeUnblockedDate = loginObject.data;
                    _this.validationMessage = loginObject.message;
                    break;
                case login_status_enum_1.LoginStatus.FAILED:
                    _this.validationMessage = loginObject.message;
                    break;
                case login_status_enum_1.LoginStatus.NEED_VERIFICATION:
                    _this.verificationType = loginObject.message;
                    _this.showTwoFactorAuthentication = true;
                    break;
                default:
                    throw new Error('No such login response type ' + loginObject.loginResponseType);
            }
        });
    };
    LoginComponent.prototype.loginViaSAML = function (event) {
        event.preventDefault();
        this.loginService.loginViaSAML();
    };
    LoginComponent.prototype.loginAsGuest = function (event) {
        event.preventDefault();
        this.loginService.loginAsGuest();
    };
    LoginComponent.prototype.resetPassword = function (event) {
        event.preventDefault();
        this.loginService.resetPassword();
    };
    LoginComponent.prototype.registration = function (event) {
        event.preventDefault();
        this.loginService.registration();
    };
    LoginComponent.prototype.resetUserBlockedFlag = function () {
        this.isUserBlocked = false;
        this.validationMessage = undefined;
    };
    LoginComponent = __decorate([
        core_1.Component({
            
            template: require('./login.component.html')
        }),
        core_1.NgModule({
            providers: [router_1.RouterState]
        }),
        __metadata("design:paramtypes", [login_service_1.LoginService,
            idm_session_data_provider_api_js_1.SessionDataProvider,
            idm_message_language_service_client_js_1.LanguageService,
            idm_message_language_service_client_js_1.MessageService])
    ], LoginComponent);
    return LoginComponent;
}());
exports.LoginComponent = LoginComponent;
//# sourceMappingURL=login.component.js.map